import { Box, Button, Grid, Typography } from '@mui/material'
import { MdCheckCircle, MdWhatsapp } from 'react-icons/md'
import { Clinica } from './data'
import { styles } from './styles'
import Header from './Header'

const formatarData = (dataStr) => {
  const [ano, mes, dia] = dataStr.split('-')
  return `${dia}/${mes}/${ano}`
}

const TelaConfirmacao = ({ dados, onVoltar, onReiniciar }) => (
  <>
    <Header voltar={onVoltar} />
    <Box sx={{ flex: 1, overflow: 'auto', py: 3, px: 2 }}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 4,
              backgroundColor: 'white',
              borderRadius: 2,
              px: 2,
            }}
          >
            <MdCheckCircle style={{ fontSize: 80, color: '#59a68d' }} />

            <Typography
              variant="h6"
              sx={{
                color: '#59a68d',
                fontWeight: 700,
                mt: 2,
                mb: 3,
                textAlign: 'center',
              }}
            >
              Agendamento realizado com sucesso
            </Typography>

            <Box sx={{ width: '100%', mb: 3 }}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>Serviço:</strong> {dados.servicoNome}
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>Data:</strong> {formatarData(dados.data)}
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>Horário:</strong> {dados.horario}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              sx={styles.primaryButton}
              fullWidth
              href={`https://wa.me/${Clinica.whatsapp}?text=${encodeURIComponent(`Olá! Gostaria de confirmar meu agendamento:\n\nServiço: ${dados.servicoNome}\nData: ${formatarData(dados.data)}\nHorário: ${dados.horario}`)}`}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<MdWhatsapp />}
            >
              Confirmar via WhatsApp
            </Button>

            <Button
              variant="text"
              fullWidth
              onClick={onReiniciar}
              sx={styles.voltarButton}
            >
              Voltar ao início
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box sx={styles.footer}>3Sync Apps</Box>
    </Box>
  </>
)

export default TelaConfirmacao
